import React from "react";
import { Heading, VStack } from "@chakra-ui/react";
import { TextInput, Form } from "components";
import { FormInstance, useCurrentCase } from "duck";
import { useUpdatePhysicalExam } from "../../duck";
import { LABELS, getDefaultValues } from "./duck";

const Abnormalities: React.FC = () => {
  const formRef = React.useRef<FormInstance<any>>(null);

  const physicalExam = useCurrentCase(
    medicalCase => medicalCase.data.client.patient.physicalExam
  );

  const onChange = useUpdatePhysicalExam();

  const defaultValues = React.useMemo(() => getDefaultValues(physicalExam), [
    physicalExam
  ]);

  React.useEffect(() => {
    formRef?.current?.reset(defaultValues);
  }, [defaultValues]);

  if (!Object.values(defaultValues).some(Boolean)) {
    return null;
  }

  return (
    <>
      <Heading
        mt={12}
        mb={4}
        as="h3"
        color="black"
        fontSize="lg"
        lineHeight="7"
      >
        Abnormalities
      </Heading>
      <Form defaultValues={defaultValues} innerRef={formRef}>
        <Form.Watcher defaultValues={defaultValues} onChange={onChange} />
        <VStack spacing={6}>
          {Object.entries(defaultValues).map(([key, value]) => (
            <>
              {value && (
                <TextInput
                  key={key}
                  type="text-area"
                  label={LABELS[key]}
                  name={key}
                />
              )}
            </>
          ))}
        </VStack>
      </Form>
    </>
  );
};

export default Abnormalities;
